module.exports = __webpack_public_path__ + "img/star-filled.6527f28f.svg";